<template>
  <div class="dados-veiculo">
    <Card title="Dados Veículo">
      <template v-slot:button>
        <v-btn
          @click="inputTrocaPlaca"
          color="primary"
          fab
          x-small
          dark
          :disabled="alteracaoPlaca"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>

      <lista-component :headers="headers" :items="analise" />
    </Card>
  </div>
</template>
<script>
import Card from "@/components/Cards/Card";
import ListaComponent from "@/components/Lista/ListaComponent";


export default {
  name: "DadosVeiculo",
  props: {
    analise: {
      type: Object,
      required: true
    },
    disabledButton: Boolean
  },
  components: { Card, ListaComponent},
  data() {
    return {
      showModalBuscarPlaca: false,
      headers: [
        { text: "Placa", value: "placa" },
        { text: "Cor", value: "cor" },
        { text: "Marca", value: "marca_modelo" },
        { text: "Chassi", value: "numero_chassi" },
        { text: "Uf", value: "uf_placa" },
        { text: "Tipo Veiculo", value: "tipo_veiculo" },
        { text: "Especie", value: "especie" },
        { text: "Categoria", value: "categoria" },
        { text: "Ano Fabricação", value: "ano_fabricacao" },
        { text: "Ano Modelo", value: "ano_modelo" },
        { text: "Proprietário", value: "proprietario" },
        { text: "CPF", value: "cpf" }
      ]
    };
  },
  methods: {
    inputTrocaPlaca(){
      this.$emit('submit')
    },
    salvar(dados) {
      this.$emit("salvar", dados);
      this.showModalBuscarPlaca = false;
    }
  },
  computed: {
    alteracaoPlaca(){
      return !!this.analise.placa_original
    }
  }
};
</script>
